export const SourceListImportType = {
  SOURCELIST: 'SOURCELIST',
  SOURCELISTITEM: 'SOURCELISTITEM',
};

export const SourceListImportTypeList = [
  { label: 'Forráslista', value: SourceListImportType.SOURCELIST },
  { label: 'Forráslista alapanyag', value: SourceListImportType.SOURCELISTITEM },
];
